import { PropertyViewCard } from './property-view-card';

export class RenewalRoommateInfo {
    constructor(
        public LeaseRenewalToken: string = '',
        public AccessToken: string = '',
        public LeaseRenewalKey: number = null,
        public RoommateResidentKey: number = null,
        public TotalRoommates: number = null,
        public RoommateIndex: number = null,
        public FirstName: string = '',
        public MiddleName: string = '',
        public LastName: string = '',
        public HomePhone: string = '',
        public CellPhone: string = '',
        public AlternativeEmail: string = '',
        public IsLocked: boolean = true,

    ) { }
}
